import { profileHash } from "PFCore/helpers/profile_hash";
import roundToWholeNumber from "PFCore/helpers/round_to_whole_number";

import getPeriod from "./helpers/get_period";

const localExportBuildDocx = (data, config, docx) => {
  const color = config.color.replace("#", "");

  const doc = new docx.Document({
    styles: {
      paragraphStyles: [
        { id: "Heading1", basedOn: "Normal", run: { size: 48, bold: true, color } },
        { id: "Heading2", basedOn: "Normal", run: { size: 38, bold: true, color } },
        { id: "Heading3", basedOn: "Normal", run: { size: 28, bold: true, color: "000000" } },
        { id: "Heading4", basedOn: "Normal", run: { size: 26, bold: false, color: "000000" } },
        { id: "Heading5", basedOn: "Normal", run: { size: 20, bold: false, color: "000000" } }
      ]
    }
  });

  const pageHeader = (text) => new docx.Paragraph({ text, bold: true, heading: docx.HeadingLevel.HEADING_1 });
  const header = (text) => new docx.Paragraph({ text, heading: docx.HeadingLevel.HEADING_2 });
  const subheader = (text) => new docx.Paragraph({ text, heading: docx.HeadingLevel.HEADING_3 });
  const text = (copy) => new docx.Paragraph({ text: copy, heading: docx.HeadingLevel.HEADING_4 });
  const small = (copy) => new docx.Paragraph({ text: copy, heading: docx.HeadingLevel.HEADING_5 });
  const br = () => text("");

  const children = [];

  if (typeof data.score === "number") {
    const score = roundToWholeNumber(data.score * 100);
    children.push(text(`Score: ${score}%`));
    children.push(br());
  }

  if (data.avatar && !config.isBlindModeOn) {
    const mm35 = 99.21; // in pts
    const img = docx.Media.addImage(doc, data.avatar, mm35, mm35, {});
    children.push(new docx.Paragraph({ children: [img] }));
    children.push(br());
  }

  children.push(pageHeader(config.isBlindModeOn ? `Candidate ${profileHash(data.id)}` : data.name));
  children.push(text(data.jobTitle));
  children.push(text(data.companyName));
  children.push(br());

  if (data.contactInformationItems && data.contactInformationItems.length > 0 && !config.isBlindModeOn) {
    children.push(header("Contact"));
    data.contactInformationItems.forEach(({ type, text }) => {
      children.push(
        new docx.Paragraph({
          heading: docx.HeadingLevel.HEADING_4,
          children: [
            new docx.TextRun({ text: `${type}: \t`, bold: true }),
            new docx.TextRun({ text, bold: false })
          ]
        })
      );
    });
    children.push(br());
  }

  config.order.forEach((itemName) => {
    if (config.hidden[itemName]) {
      return;
    } else if (itemName === "summary") {
      if (data.summary) {
        children.push(header("Summary"));
        data.summary.split("\n").forEach((line) => children.push(text(line.replace(/^ +/, ""))));
        children.push(br());
      }
    } else if (itemName === "experience") {
      if (data.positions && !config.hidden["experience"]) {
        children.push(br());
        children.push(header("Experience"));
        children.push(br());
        data.positions.items.forEach((pos) => {
          children.push(subheader(pos.jobTitle));
          pos.startDate && children.push(small(getPeriod(pos.startDate, pos.endDate, pos.current)));
          pos.summary && children.push(text(pos.summary));
          children.push(br());
        });
      }
    } else {
      const field = data.customTypes.find(({ type }) => type.name === itemName);
      if (field && field.text && !config.hidden[field.type.name]) {
        children.push(header(field.displayAs));
        children.push(text(field.text));
        children.push(br());
      }
    }
  });

  doc.addSection({ children });
  return docx.Packer.toBlob(doc);
};

export default localExportBuildDocx;
